import React, { useEffect } from "react";
import "./StopTestModal.scss";
import { CloseIcon } from "../../../icons/Icons";
import Button from "../../../components/ui/common/Button";
import { useSelector } from "react-redux/es/hooks/useSelector";
import { CircleLoader } from "../../../icons/Loaders";

type StopTestModalProps = {
    closeModal: Function;
    stopTest: Function;
    stoppingConfirmed : Function;
}

const StopTestModal = ({closeModal, stopTest, stoppingConfirmed} : StopTestModalProps) => {

    const isStopping = useSelector((state : any) => state.abTests.isStopping);
    const isStopped = useSelector((state : any) => state.abTests.isStopped);

    useEffect(()=>{
        if (isStopped) stoppingConfirmed()
    }, [isStopped])

    return <div className="stop-test-modal-wrapper">
        <div className="stop-test-modal-container">
            <div className="stop-test-modal-header">
                <div className="stop-test-modal-title">
                    Stopping test
                </div>
                <div className="stop-test-close-button"
                    onClick={()=>{ closeModal() }}>
                    <CloseIcon width="20" height="20" color="white" />
                </div>
                
            </div>
            <div className="stop-test-modal-body">
                {
                    isStopping ? 
                    <div className="stop-test-loading">
                        <CircleLoader width="100" height="100"/>
                        <span>
                            Stopping test 
                        </span>
                    </div>
                        :
                    <>
                     <div className="stop-test-modal-message">
                        Are you sure you want to stop the a/b test?
                    </div>
                    <div className="stop-test-modal-buttons">
                        <Button variant="default"
                            onClick={()=>{ closeModal() }}
                            className="stop-test-modal-cancel-button"
                            >No, go back</Button>
                        <Button variant="success"
                            onClick={()=>{ stopTest() }}
                            >Yes, stop it</Button>
                    </div>
                    </>
                }
               
            </div>
        </div>
    </div>
}

export default StopTestModal